import { render, staticRenderFns } from "./AddAllowance.vue?vue&type=template&id=55a8cb07&scoped=true&"
import script from "./AddAllowance.vue?vue&type=script&lang=js&"
export * from "./AddAllowance.vue?vue&type=script&lang=js&"
import style0 from "./AddAllowance.vue?vue&type=style&index=0&id=55a8cb07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a8cb07",
  null
  
)

export default component.exports